import { scenes } from "../scenes";
import { Scene, Choice } from "../models";

export class ShibariHQ extends Scene {
  title = "Office Building";
  image = require("@/images/Shibari_HQ_Building_Exterior.png");

  get options() {
    return [
      new Choice("Enter Office", async () => {
        if (this.state.storylines.infectedWithYogid) {
          this.description = "SONNY YANG: I need to find that SANITIZER!";
          this.audio = require("@/audio/Pandemic-182-Sonny-MP3.mp3")
        } else {
          await this.navigate(scenes.ShibariLobby());
        }
      }),
      new Choice("Go Left", async () => await this.navigate(scenes.Supermarket())),
      new Choice("Go Right", async () => await this.navigate(scenes.Harbour())),
    ];
  }
}

export default new ShibariHQ();
